import React, { useState, useEffect } from "react";
import usdp from "../../assets/achievements/usdp.jpeg";
import bronze_medalist from "../../assets/achievements/bronze_medalist.jpg";
import yip from "../../assets/achievements/yip.jpg";
import silver_medalist from "../../assets/achievements/silver_medalist.jpg";
import pre_incubation from "../../assets/achievements/pre_incubation.jpg";
import tic from "../../assets/achievements/tic.jpeg";
import aasyp from "../../assets/achievements/aasyp.png";
import cs_cup from "../../assets/achievements/cs_cup.jpg";

const Achievement = () => {
  const [startIndex, setStartIndex] = useState(0); // Keep track of which set of items is being displayed
  const [itemsPerPage, setItemsPerPage] = useState(4); // Dynamically set items per page

  useEffect(() => {
    const updateItemsPerPage = () => {
      if (window.innerWidth < 768) {
        setItemsPerPage(2); // Mobile view
      } else {
        setItemsPerPage(4); // Tablet and desktop view
      }
    };

    // Initial check
    updateItemsPerPage();

    // Listen for window resize events
    window.addEventListener("resize", updateItemsPerPage);

    // Cleanup listener on component unmount
    return () => window.removeEventListener("resize", updateItemsPerPage);
  }, []);

  const handleNext = () => {
    if (startIndex + itemsPerPage < educationData.length) {
      setStartIndex(startIndex + itemsPerPage);
    }
  };

  const handleBack = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - itemsPerPage);
    }
  };

  return (
    <section
      className="w-screen py-12 px-6 md:pt-24 md:pb-12 md:px-16"
      id="achievement"
    >
      <div className="max-w-5xl mx-auto space-y-6">
        <div className="flex flex-row justify-between items-center">
          <h2 className="text-2xl text-left md:text-4xl md:text-center">
            Achievements
          </h2>
          <div className="flex justify-center gap-2 items-center">
            <button
              onClick={handleBack}
              disabled={startIndex === 0}
              className={`size-8 md:size-10 flex justify-center items-center bg-neutral-500 text-white rounded-full shadow-md ${
                startIndex === 0 ? "opacity-30 cursor-not-allowed" : ""
              }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={3}
                stroke="currentColor"
                className="size-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.75 19.5 8.25 12l7.5-7.5"
                />
              </svg>
            </button>
            <button
              onClick={handleNext}
              disabled={startIndex + itemsPerPage >= educationData.length}
              className={`size-8 md:size-10 flex justify-center items-center bg-neutral-500 text-white rounded-full shadow-md ${
                startIndex + itemsPerPage >= educationData.length
                  ? "opacity-30 cursor-not-allowed"
                  : ""
              }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={3}
                stroke="currentColor"
                className="size-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m8.25 4.5 7.5 7.5-7.5 7.5"
                />
              </svg>
            </button>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4">
          {educationData
            .slice(startIndex, startIndex + itemsPerPage)
            .map((item, index) => (
              <AchievementCard
                key={index}
                title={item.title}
                event={item.event}
                years={item.years}
                image={item.image}
                link={item.link}
              />
            ))}
        </div>
      </div>
    </section>
  );
};

export default Achievement;

const educationData = [
  {
    title: "Best Performing Team",
    event: "SmartEdu USDP Cohort 3",
    years: "November 2021",
    image: usdp,
    link: "https://www.khmertimeskh.com/50977601/top-8-students-awarded-fully-paid-internships-with-axiata-group-in-smartedu-usdp-cohort-3/",
  },
  {
    title: "Bronze Medalist",
    event: "Outstanding Academic Performance",
    years: "November 2021",
    image: bronze_medalist,
  },
  {
    title: "Top 5 Winning Teams",
    event: "SmartStart YIP Cycle 4",
    years: "August 2021",
    image: yip,
    link: "https://www.khmertimeskh.com/50918849/five-teams-of-young-digital-entrepreneurs-get-shot-at-top-smartstart-prize-of-10k/",
  },
  {
    title: "Top 3 Winning Teams",
    event: "Techno Pre-Incubation Program",
    years: "July 2021",
    image: pre_incubation,
    link: "https://www.facebook.com/100064439723614/posts/922418825009507/",
  },
  {
    title: "2nd Runner-up",
    event: "Techno Innovation Challenge",
    years: "March 2021",
    image: tic,
    link: "https://www.facebook.com/photo?fbid=853615938556463&set=pcb.853617648556292",
  },
  {
    title: "Silver Medalist",
    event: "Outstanding Academic Performance",
    years: "November 2020",
    image: silver_medalist,
  },
  {
    title: "Highly Commended Team",
    event: "AASYP Reset: AAYIC",
    years: "October 2020",
    image: aasyp,
  },
  {
    title: "Top 15",
    event: "Cambodia CS Cup",
    years: "June 2020",
    image: cs_cup,
    link: "https://sites.google.com/paragoniu.edu.kh/cscup/previous-years/cambodia-cs-cup-2020",
  },
];

const AchievementCard = ({ title, event, years, image, link }) => {
  const handleClick = () => {
    if (link) {
      window.open(link, "_blank"); // Opens the link in a new tab
    }
  };

  return (
    <div
      className="bg-white rounded-lg overflow-hidden w-full max-w-sm cursor-pointer hover:shadow-lg transition-shadow duration-300"
      onClick={handleClick}
    >
      <figure className="relative w-full h-56">
        <img
          className="object-cover object-center w-full h-full rounded-xl"
          src={image}
          alt={title}
        />
        <figcaption className="absolute bottom-3 left-2/4 flex w-[calc(100%-1rem)] -translate-x-2/4 justify-between rounded-xl bg-white/75 py-2 px-3 shadow-lg shadow-black/5 saturate-200 backdrop-blur-sm">
          <div>
            <h5 className="text-lg font-medium text-slate-800">{title}</h5>
            <h5 className="text-base font-medium text-slate-700">{event}</h5>
            <p className="mt-2 text-sm text-slate-600">{years}</p>
          </div>
        </figcaption>
      </figure>
    </div>
  );
};
